<mat-select [formControl]="skjemakontroll()"
            [compareWith]="erValgt"
            [multiple]="multiple()"
            [placeholder]="placeholder()"
            panelClass="velg-gruppe--alternativer"
            data-testid="gruppevelger"
            #gruppevelger>
  <mat-select-trigger>
    @switch (antallValgt()){
      @case (0) {
        {{'Ingen valgt'|translate}}
      }
      @case (1) {
        <div class="gruppe">
          @if(visLogo()){<gruppe-logo stil="liten" [gruppe]="foersteValgteGruppe()"/>}
          <span class="tittel">{{foersteValgteGruppe()!.tittel}} ({{foersteValgteGruppe()!.organisasjonsnavn}})</span>
        </div>
      }
      @default {
        {{'{antall} grupper valgt'|translate:{antall:antallValgt()} }}
      }
    }
  </mat-select-trigger>
  @for (gruppe of ordindaereGrupper(); track gruppe.id) {
    <mat-option [value]="gruppe">
      <div class="gruppe">
        @if(visLogo()){<gruppe-logo stil="liten" [gruppe]="gruppe"/>}
        <span class="tittel">{{gruppe.tittel}} ({{gruppe.organisasjonsnavn}})</span>
      </div>
    </mat-option>
  }
  @if (malGrupper().length > 0) {
    <mat-optgroup label="{{'Malgrupper' |translate}}">
      @for (gruppe of malGrupper(); track gruppe.id) {
        <mat-option [value]="gruppe">
          <div class="gruppe">
            @if(visLogo()){<gruppe-logo stil="liten" [gruppe]="gruppe"/>}
            <span class="tittel">{{gruppe.tittel}} ({{gruppe.organisasjonsnavn}})</span>
          </div>
        </mat-option>
      }
    </mat-optgroup>
  }
</mat-select>
